export const fieldWrapperTheme = {
  bg: 'palette.surface.2',
  borderRadius: '12px',
  title: 'palette.tertiary.90',
};
